module.exports = __webpack_public_path__ + "static/media/60418780_1887594244677733_5078223228887891968_o.ee44f9bd.jpg";